// state/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  taskTimers: {}, // Store timers for each task
  isLoaderOpen: false,
  isSidebarMenuOpen: false,
  isDashSidebarCollapsed: false,
  isAppointmentFormOpen: false,
  isDelOpen: false,
  selectedItemId: {}, //Selected item to delete
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openLoader: (state) => {
      state.isLoaderOpen = true;
      document.body.classList.add("modal-open"); // Disable scroll
    },
    closeLoader: (state) => {
      state.isLoaderOpen = false;
      document.body.classList.remove("modal-open"); // Re-enable scrolling
    },

    openSidebarMenu: (state) => {
      state.isSidebarMenuOpen = true;
      document.body.classList.add("menu-open"); // Disable scroll
    },
    closeSidebarMenu: (state) => {
      state.isSidebarMenuOpen = false;
      document.body.classList.remove("menu-open"); // Re-enable scrolling
    },

    openDashSidebarMenu: (state) => {
      state.isDashSidebarCollapsed = true;
      document.body.classList.add("menu-open"); // Disable scroll
    },
    closeDashSidebarMenu: (state) => {
      state.isDashSidebarCollapsed = false;
      document.body.classList.remove("menu-open"); // Re-enable scrolling
    },

    // TIMER
    startTimer: (state, action) => {
      const { taskId } = action.payload;
      if (!state.taskTimers[taskId]) {
        state.taskTimers[taskId] = {
          startTime: Date.now(),
          secondsSpent: 0,
          intervalId: null, // Store the interval ID for stopping later
        };
        // Start the interval here instead of the component
        const intervalId = setInterval(() => {
          state.taskTimers[taskId].secondsSpent += 1; // Increment seconds spent
        }, 1000);
        state.taskTimers[taskId].intervalId = intervalId; // Store intervalId
      }
    },
    stopTimer: (state, action) => {
      const { taskId } = action.payload;
      const timer = state.taskTimers[taskId];

      if (timer) {
        clearInterval(timer.intervalId); // Clear the timer
        delete state.taskTimers[taskId]; // Remove the timer from the state
      }
    },
    // You may not need this; the updating is now handled directly in the startTimer function.
    updateTimer: (state, action) => {
      const { taskId } = action.payload;
      const timer = state.taskTimers[taskId];

      if (timer) {
        const elapsedSeconds = Math.floor(
          (Date.now() - timer.startTime) / 1000
        );
        timer.secondsSpent = elapsedSeconds; // Update the seconds spent
      }
    },
    // endTimer

    openAppointmentForm: (state) => {
      state.isAppointmentFormOpen = true;
      document.body.classList.add("modal-open"); // Disable scroll
    },
    closeAppointmentForm: (state) => {
      state.isAppointmentFormOpen = false;
      document.body.classList.remove("modal-open"); // Re-enable scrolling
    },

    // Delete modal
    openDelModal: (state) => {
      state.isDelOpen = true;
      document.body.classList.add("modal-open"); // Disable scroll
    },
    closeDelModal: (state) => {
      state.isDelOpen = false;
      document.body.classList.remove("modal-open"); // Re-enable scrolling
    },
    handleItemSelected: (state, action) => {
      state.selectedItemId = action.payload;
    },
  },
});

// Export actions
export const {
  openAppointmentForm,
  closeAppointmentForm,
  closeSidebarMenu,
  openSidebarMenu,
  openLoader,
  closeLoader,
  openDelModal,
  closeDelModal,
  handleItemSelected,
  closeDashSidebarMenu,
  openDashSidebarMenu,
  startTimer,
  stopTimer,
  updateTimer,
} = modalSlice.actions;

// Export the reducer
export default modalSlice.reducer;
